import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { EventManagerService } from '../../services/database/event/eventmanager.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ngx-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})
export class SalesComponent implements OnInit {
  eventId: string;
  authKey: string;
  authToken: string;
  showReport = false;
  embedURL: string;
  safeURL: SafeResourceUrl;
  constructor(
    private route: ActivatedRoute,
    private eventManagerService: EventManagerService,
    private authService: AuthService,
    private sanitizer: DomSanitizer
    ) { }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId');

    const urlEncodeJson = obj => encodeURIComponent(JSON.stringify(obj));

    const jsonObj = {"ds21.eventstand_transaction_event_id":this.eventId,"ds17.event_id_user":this.eventId,"ds19.input_event_id":this.eventId,"locale":"nl"}
    let reportId = '962b07db-1390-48c3-8b86-a37d12f0578c';
    if(this.eventId == 'LZ7ccOK7GtBgyvZVQIIC') {
      reportId = 'c848aa2a-d4e9-46bc-b90b-9a703255cf16';
    }
    const encodedJson = urlEncodeJson(jsonObj);

    const baseUrl = `https://lookerstudio.google.com/embed/reporting/${reportId}/page/wx20D`;
    this.embedURL = `${baseUrl}?params=${encodedJson}`;
    this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.embedURL);

    console.log(this.embedURL)
    this.showReport = true;
    this.authService.get().subscribe((user) => {
      this.eventManagerService.updateEventManager(
        this.eventId,
        user.uid,
        null,
        null
      )
      this.eventManagerService.getEventManager(this.eventId, user.uid).subscribe((eventManager) => {
        this.authKey = eventManager.authKey;
        this.authToken = eventManager.authToken;
      })
    })
  }
}
